import styled, { css } from "styled-components";
import BackgroundLayout from "../BackgroundLayout/BackgroundLayout";

export const BackgroundLayoutWithLogoRoot = styled(BackgroundLayout)(
    ({ theme }) => css`
        row-gap: ${theme.spacing[16]};
        .full-logo {
            margin: 0 auto;
        }
    `,
);
